import * as swcHelpers from '@swc/helpers';
import { unwrapResponse } from '../../response.js';
import { acceptJson, authHeader } from '../../shared.js';

function signedPrescriptions(apiUrl, accessToken, request) {
    return _signedPrescriptions.apply(this, arguments);
}
function _signedPrescriptions() {
    _signedPrescriptions = swcHelpers.asyncToGenerator(function*(apiUrl, accessToken, request) {
        return unwrapResponse((yield fetch(`${apiUrl}/customers/customer/${encodeURIComponent(request.customerId)}/signedprescriptions`, {
            method: 'GET',
            headers: swcHelpers.objectSpread({}, acceptJson, authHeader(accessToken))
        })));
    });
    return _signedPrescriptions.apply(this, arguments);
}

export { signedPrescriptions };
//# sourceMappingURL=signedprescriptions.js.map
